export { initialFrame } from './common';
const EASING_MAP = {
  soft: 'cubicInOut',
  medium: 'quintInOut',
  hard: 'backOut'
};
const DIRECTION_TO_TRANSFORM_MAP = {
  'top-left': {
    angle: -50,
    x: -50,
    y: -50
  },
  'top-right': {
    angle: 50,
    x: 50,
    y: -50
  },
  'bottom-right': {
    angle: 50,
    x: 50,
    y: 50
  },
  'bottom-left': {
    angle: -50,
    x: -50,
    y: 50
  }
};
export function web(options) {
  const [fadeIn, {
    custom,
    ...turnIn
  }] = style(options);
  return [{
    ...fadeIn,
    keyframes: [{
      opacity: 0
    }, {
      opacity: 'var(--comp-opacity, 1)'
    }]
  }, {
    ...turnIn,
    keyframes: [{
      transform: `translate(${custom['--motion-origin']}) rotate(${custom['--motion-rotate-z']}) translate(${custom['--motion-origin-invert']}) rotate(var(--comp-rotate-z, 0deg))`
    }, {
      transform: `translate(${custom['--motion-origin']}) rotate(0deg) translate(${custom['--motion-origin-invert']}) rotate(var(--comp-rotate-z, 0deg))`
    }]
  }];
}
export function style(options) {
  const {
    direction = 'top-left',
    power
  } = options.namedEffect;
  const easing = power && EASING_MAP[power] ? EASING_MAP[power] : options.easing || 'backOut';
  const {
    x,
    y
  } = DIRECTION_TO_TRANSFORM_MAP[direction];
  const transformRotate = DIRECTION_TO_TRANSFORM_MAP[direction].angle;
  return [{
    ...options,
    name: 'fadeIn',
    duration: options.duration * 0.6,
    easing: 'sineIn',
    custom: {}
  }, {
    ...options,
    name: 'turnIn',
    easing,
    custom: {
      '--motion-origin': `${x}%, ${y}%`,
      '--motion-origin-invert': `${-x}%, ${-y}%`,
      '--motion-rotate-z': `${transformRotate}deg`
    }
  }];
}
//# sourceMappingURL=TurnIn.js.map